import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import AIAnswerBlock from "./components/AIAnswerBlock";
import Process from "./components/Process";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreas from "./components/ServiceAreas";
import CredibilityProof from "./components/CredibilityProof";
import FAQ from "./components/FAQ";
import LeadForm from "./components/LeadForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0a0a0c] min-h-screen" style={{ fontFamily: "'Outfit', sans-serif" }}>
      <Header />
      <Hero />
      <TrustBar />
      <Services />
      <AIAnswerBlock />
      <Process />
      <WhyChooseUs />
      <ServiceAreas />
      <CredibilityProof />
      <FAQ />
      <LeadForm />
      <Footer />
    </div>
  );
}
